import { exec } from '../utils';
import type { ValidCodeNameType } from '@src/types';

interface UpdateCatalogAttributesArgs {
  partnerCode: string;
  token: string;
  colorUpdates?: ValidCodeNameType[];
  sizeUpdates?: ValidCodeNameType[];
  seasonUpdates?: ValidCodeNameType[];
  genderUpdates?: ValidCodeNameType[];
}

interface UpdateCatalogAttributesResult {
  success: boolean;
  colorUpdatedCount?: number;
  sizeUpdatedCount?: number;
  seasonUpdatedCount?: number;
  genderUpdatedCount?: number;
  error?: string;
}

interface UpdateCatalogAttributesExecResponse {
  restUser: {
    partner: {
      updateCatalogAttributes: UpdateCatalogAttributesResult;
    };
  };
}

/**
 * Updates catalog attributes (color, size, season, gender) for a partner
 * @param args - Contains partnerCode, token, and arrays of code/name updates
 * @returns Promise resolving to update result with success status and counts
 */
export const updateCatalogAttributes = async (
  args: UpdateCatalogAttributesArgs
): Promise<UpdateCatalogAttributesResult> => {
  const mutation = `
    mutation updateCatalogAttributes(
      $partnerCode: String!
      $token: String!
      $colorUpdates: [CodeNameInputTypeRestUser]
      $sizeUpdates: [CodeNameInputTypeRestUser]
      $seasonUpdates: [CodeNameInputTypeRestUser]
      $genderUpdates: [CodeNameInputTypeRestUser]
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          updateCatalogAttributes(
            colorUpdates: $colorUpdates
            sizeUpdates: $sizeUpdates
            seasonUpdates: $seasonUpdates
            genderUpdates: $genderUpdates
          ) {
            success
            colorUpdatedCount
            sizeUpdatedCount
            seasonUpdatedCount
            genderUpdatedCount
            error
          }
        }
      }
    }
  `;

  const data = await exec<UpdateCatalogAttributesArgs, UpdateCatalogAttributesExecResponse>(
    mutation,
    { variables: args }
  );

  return data.restUser.partner.updateCatalogAttributes;
};
